var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box box-index"},[_c('Menu'),(_vm.usersChecked)?_c('Users',{staticClass:"users-page"}):_vm._e(),(_vm.brandsChecked)?_c('Brands',{staticClass:"brands-page"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }